import React, { createContext, useContext, useState, useRef, ReactNode } from 'react';
import { appStats } from '@/data/apps';

interface AppCountContextType {
    totalCount: number;
    incrementCount: (amount: number, source?: string) => void;
}

const AppCountContext = createContext<AppCountContextType | undefined>(undefined);

export function AppCountProvider({ children }: { children: ReactNode }) {
    // 初始值为apps中的应用数量
    const [totalCount, setTotalCount] = useState(appStats.availableApps);
    // 使用 Set 记录已经增加过的来源，防止重复计数
    const incrementedSources = useRef<Set<string>>(new Set());

    const incrementCount = (amount: number, source: string = 'default') => {
        // 如果这个来源已经增加过，跳过
        if (incrementedSources.current.has(source)) {
            return;
        }

        incrementedSources.current.add(source);
        setTotalCount(prev => prev + amount);
    };

    return (
        <AppCountContext.Provider value={{ totalCount, incrementCount }}>
            {children}
        </AppCountContext.Provider>
    );
}

export function useAppCount() {
    const context = useContext(AppCountContext);
    if (context === undefined) {
        throw new Error('useAppCount must be used within an AppCountProvider');
    }
    return context;
}
